import { render, staticRenderFns } from "./VideoCallAudio.vue?vue&type=template&id=75040235&"
import script from "./VideoCallAudio.vue?vue&type=script&lang=ts&"
export * from "./VideoCallAudio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports